/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Toolcardrejected2Inputs */

const en_toolcardrejected2 = /** @type {(inputs: Toolcardrejected2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`✗ ${i?.error}`)
};

const pt_toolcardrejected2 = /** @type {(inputs: Toolcardrejected2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`✗ ${i?.error}`)
};

/**
* | output |
* | --- |
* | "✗ {error}" |
*
* @param {Toolcardrejected2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const toolcardrejected2 = /** @type {((inputs: Toolcardrejected2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolcardrejected2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toolcardrejected2(inputs)
	return pt_toolcardrejected2(inputs)
});
export { toolcardrejected2 as "toolCardRejected" }